import "@tento-ui/components/rich-text-editor/rich-text-editor";
import "@tento-ui/brand/blog/blog-bear-post-pagelet";

import { RichTextEditor } from "@tento-ui/components/rich-text-editor/rich-text-editor";
import { BlogBearPostPagelet } from "@tento-ui/brand/blog/blog-bear-post-pagelet";
import type { BlogPost } from "../blog-data";
import type { BlogPostPage, BlogPostRoute } from "../blog-variant";

export const bearPostRoute: BlogPostRoute = {
  make(post: BlogPost, _delegate: BlogPostPage.Delegate): HTMLElement {
    const $content = RichTextEditor.make() as RichTextEditor;
    $content.bind({ markdown: post.content ?? "", editable: false });

    return BlogBearPostPagelet.makeWith({ content: $content });
  },
  bind(pagelet: HTMLElement, _post: BlogPost, _delegate: BlogPostPage.Delegate): HTMLElement {
    return pagelet;
  },
};
